import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-20 lg:py-28 cta-gradient relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-[400px] h-[400px] bg-[#4285F4]/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] bg-[#34A853]/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Headline */}
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
          Get a <span className="text-[#EA4335]">FREE AUDIT</span> of Your Google Ads Account
        </h2>

        {/* Description */}
        <p className="text-lg text-muted-foreground leading-relaxed mb-10 max-w-2xl mx-auto">
          Our team will review your Google Ads, Tag Manager, and Analytics setup. 
          Discover what's working and where you can optimize for better results.
        </p>

        {/* CTA Button */}
        <Link to="/booking" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <Button className="bg-[#EA4335] hover:bg-[#EA4335]/90 text-white rounded-full px-8 py-6 text-base font-semibold group">
            Schedule Your Free Audit
            <ArrowRight className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </Link>

        {/* Trust indicators */}
        <p className="text-sm text-muted-foreground mt-8">
          No commitment required • 30-minute consultation • Actionable insights
        </p>
      </div>
    </section>
  );
};
